<template>
  <div class="list_Hashtags margin-top-10">
    <el-tag
      v-for="item in listHashtags"
      :key="item.id"
      effect="dark"
      size="medium"
      class="priority inline-flex clickable"
      :style="`background-color: ${item.colorCode}; color: white`"
    >
      <i
        class="fal fa-users"
        v-if="item.groupTypeId === GROUPS.GROUP_TYPE_ID.CA_NHAN"
      ></i>
      <i
        class="fal fa-sitemap"
        v-if="item.groupTypeId === GROUPS.GROUP_TYPE_ID.DON_VI"
      ></i>
      <span @click="selectTag(item)">
        {{ item.groupName }}
      </span>
    </el-tag>
  </div>
</template>

<script>
  import groupsService from "../../../services/groupsService";
  import h from "../../../services/h";
  import constants from "../../../constants";

  export default {
    name: "hashtag-common",
    props: ["stepId", "groupTypeId"],
    data() {
      return {
        listHashtags: [],
        listUserDeptInGroup: [],
        GROUPS: constants.GROUPS
      };
    },
    created() {
      this.doSearch();
    },
    methods: {
      selectTag(item) {
        return groupsService.userDeptInGroup(item.id).then(res => {
          this.listUserDeptInGroup = res.data;
          this.$emit("selectTags", this.populateData());
        });
      },

      populateData() {
        let list = [];
        this.listUserDeptInGroup.forEach(item => {
          if (item.type === "caNhan") {
            let node = {
              handler: {
                id: item.userDeptRoleId,
                stepId: this.stepId,
                userView: {
                  deptName: item.userDeptName,
                  positionName: item.userPositionName,
                  userId: item.userId,
                  deptId: item.deptId,
                  roleId: item.roleId,
                  fullName: item.userFullName
                }
              },
              nodeType: constants.DEPARTMENT_TREE.NODE_TYPE.USER_DEPT_ROLE,
              processType: constants.PROCESS_TYPE.CHUTRI
            };
            list.push(node);
          } else {
            let node = {
              department: {
                id: item.departmentId,
                deptName: item.departmentName
              },
              nodeType: constants.DEPARTMENT_TREE.NODE_TYPE.DEPT,
              processType: constants.PROCESS_TYPE.CHUTRI
            };
            list.push(node);
          }
        });
        return list;
      },

      doSearch() {
        return groupsService.findAll().then(res => {
          this.listHashtags = res.data;
          if (this.groupTypeId != null)
            this.listHashtags = h.findAll(
              this.listHashtags,
              groups => groups.groupTypeId === this.groupTypeId
            );
        });
      }
    }
  };
</script>
x
<style scoped>
  .list_Hashtags .priority {
    padding-left: 14px;
    position: relative;
    margin-bottom: 5px;
  }

  .list_Hashtags .priority::before {
    position: absolute;
    content: "";
    width: 5px;
    height: 5px;
    border-radius: 50%;
    background-color: white;
    top: 50%;
    left: 6px;
    transform: translateY(-50%);
  }
</style>



// WEBPACK FOOTER //
// src/views/doc-in/components/chuyenXuLy-hashtag.vue